import React from "react";
import { array, bool, string } from "prop-types";

import CustomStoryCard4 from "../../../../molecules/CustomStoryCard4";

import "./organism3.m.css";

const Organism3 = ({ stories, updatedFont, src, lang, firstCardAspectRatio, changeImageType }) => {
  const firstStory = stories[0].story;
  const secondStory = stories.length > 1 ? stories[1].story : null;

  return (
    <div styleName="base" className="organism3-wrapper">
      <CustomStoryCard4
        story={firstStory}
        headlineType={4}
        showStoryMetaInfo={true}
        className="first-card"
        widths={[120, 220, 300]}
        updatedFont={updatedFont}
        src={src}
        langClass={`${lang}-card-style`}
        changeAspectRatio={firstCardAspectRatio}
        changeImageType={changeImageType}
        datatrackingcategory="Component One"
        datatrackingaction="Click"
        datatrackinglabel="Position-12"
      />
      {secondStory && (
        <CustomStoryCard4
          story={secondStory}
          headlineType={16}
          showStoryMetaInfo={true}
          widths={[120]}
          updatedFont={updatedFont}
          src={src}
          langClass={`${lang}-card-style`}
          datatrackingcategory="Component One"
          datatrackingaction="Click"
          datatrackinglabel="Position-13"
        />
      )}
    </div>
  );
};

Organism3.propTypes = {
  stories: array.isRequired,
  updatedFont: bool,
  src: string,
  lang: string,
  firstCardAspectRatio: array,
  changeImageType: string,
};

export default Organism3;
